import { jsx, jsxs } from 'react/jsx-runtime';
import { useRef, useEffect } from 'react';
import styled from '@emotion/styled';
import { useOnClickOutside } from '@monorepo/hooks';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleXmark } from '@nvidiadmo/sharp-regular-svg-icons/faCircleXmark';

const Overlay = styled.div `
    background: rgba(0, 0, 0, 0.6);
    display: flex;
    align-items: flex-start;
    justify-content: center;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    overflow-x: hidden;
    overflow-y: auto;
    z-index: 10001;

    @media (min-width: 576px) {
        align-items: center;
    }
`;
const Container = styled.div `
    background: ${({ theme }) => theme.colors.modal.bg};
    color: ${({ theme }) => theme.colors.textDefault};
    min-height: 100%;
    padding: 30px 45px;
    position: relative;
    max-height: 100vh;
    overflow-y: auto;

    ${({ customStyles }) => customStyles};

    & > svg {
        position: absolute;
        right: 0px;
        top: 0px;
        color: ${({ theme }) => theme.newPalette["grey-600"]};
        transform: translate(-50%, 50%);
    }

    @media (min-width: 576px) {
        min-height: auto;
    }
`;
const Modal = ({ handleClose, disableCloseButton, disableEscapeKey, disableBackgroundClick, children, customStyles, ...rest }) => {
    const modalRef = useRef();
    useEffect(() => {
        const escapeKeyHandler = (e) => {
            if (e.key === "Escape" && typeof handleClose === "function") {
                handleClose();
            }
        };
        document.body.classList.add("hide-overflow");
        if (!disableEscapeKey) {
            document.addEventListener("keydown", escapeKeyHandler);
        }
        return () => {
            document.body.classList.remove("hide-overflow");
            document.removeEventListener("keydown", escapeKeyHandler);
        };
    }, []);
    // close modal when clicked on overlay
    if (!disableBackgroundClick && typeof handleClose === "function") {
        useOnClickOutside(modalRef, handleClose);
    }
    return (jsx(Overlay, { children: jsxs(Container, { ref: modalRef, customStyles: customStyles, ...rest, children: [!disableCloseButton && handleClose && (jsx(FontAwesomeIcon, { icon: faCircleXmark, onClick: handleClose, role: "button" })), children] }) }));
};

export { Modal };
